'use client';

import { faEnvelope } from '@fortawesome/free-regular-svg-icons';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { easeOut, motion } from 'framer-motion';
import React, { PropsWithChildren } from 'react';
import { cn } from '~/lib/cn';
import { Button } from '../../Button';

interface Props {
    className?: string;
}

const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.4,
            ease: easeOut
        }
    }
};
export const CTASection: React.FC<PropsWithChildren<Props>> = ({ className }) => {
    return (
        <section className={cn(className)}>
            <motion.div
                variants={itemVariants}
                className="tw-card tw-overflow-hidden tw-rounded-xl tw-bg-gradient-to-r tw-from-white tw-to-success/5 tw-p-8"
            >
                <div className="tw-grid tw-gap-8 md:tw-grid-cols-2">
                    <div>
                        <div className="tw-inline-flex tw-items-center tw-gap-2 tw-rounded-full tw-bg-success/10 tw-px-3 tw-py-1 tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider tw-text-success">
                            <svg className="tw-h-4 tw-w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z"
                                />
                            </svg>
                            Persönliche Beratung
                        </div>
                        <h4 className="tw-mt-3 tw-text-lg tw-font-bold tw-text-accents-9">
                            Individuelle Beratung gewünscht?
                        </h4>
                        <p className="tw-mt-2 tw-text-accents-7">
                            Wir erstellen gerne ein maßgeschneidertes Angebot für deine spezifischen Anforderungen.
                            Kontaktiere uns für eine persönliche Beratung.
                        </p>
                    </div>

                    <div className="tw-flex tw-flex-col tw-gap-3 sm:tw-items-center sm:tw-justify-center">
                        <motion.div>
                            <Button.Link href="tel:029228751440" className="tw-w-full sm:tw-w-auto" size="sm">
                                <FontAwesomeIcon icon={faPhone} className="tw-mr-2" />
                                Telefonische Beratung
                            </Button.Link>
                        </motion.div>

                        <motion.div>
                            <Button.Link
                                href="mailto:sales@sportision.de"
                                className="tw-w-full sm:tw-w-auto"
                                size="sm"
                                flat
                            >
                                <FontAwesomeIcon icon={faEnvelope} className="tw-mr-2" />
                                Angebot anfragen
                            </Button.Link>
                        </motion.div>
                    </div>
                </div>
            </motion.div>
        </section>
    );
};
